module.exports = __webpack_public_path__ + "static/media/icon_cat.9d823444.png";